export const WORK_AJOUT_SUCCES = "WORK_AJOUT_SUCCES";
export const WORK_AJOUT_REQUETTE = "WORK_AJOUT_REQUETTE";
export const WORK_AJOUT_SUPP = "WORK_AJOUT_SUPP";
export const WORK_AJOUT_RESET = "WORK_AJOUT_RESET";

export const WORK_VALIDATION_SUCCES = "WORK_VALIDATION_SUCCES";
export const WORK_VALIDATION_REQUETTE = "WORK_VALIDATION_REQUETTE";
export const WORK_VALIDATION_ECHEC = "WORK_VALIDATION_ECHEC";
